function EnonomicPriciples() {
  return (
    <div>
      <h1>Islamic Jurisprudence of Finance</h1>
      <p>This page covers Islamic financial principles...</p>
    </div>
  );
}

export default EnonomicPriciples;
